import type {
  IntegrationScenario,
  IntegrationScenarioMethod,
  IntegrationScenarioTransactionType,
} from './integrationScenariosData';

export const FILTER_EMPTY = '';

export const FILTER_NOT_SELECTED_LABEL = 'Not selected';

export const TRANSACTION_LABELS: Record<IntegrationScenarioTransactionType, string> = {
  'pay-in': 'Pay-in',
  'pay-out': 'Pay-out',
};

export function formatMethod(method: IntegrationScenarioMethod): string {
  return method === 'apm' ? 'APM' : 'Card';
}

/** Omits generic "Card" tag when the scenario method is already card. */
export function getPaymentSystemTags(scenario: IntegrationScenario): string[] {
  const { tags, method } = scenario;

  return tags.filter((t) => !(method === 'card' && t.toLowerCase() === 'card'));
}
